import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { URL_MAP } from '../../shared/urlMap';

@Injectable({
  providedIn: 'root'
})
export class DownloadService {

  // private baseEndpoint: string = environment.EXTERNAL.downloadFiles;
  private baseEndpoint: string = `${environment.HOST}${URL_MAP.EXTERNAL.downloadFiles}`;
  // private fileUrl: string = environment.EXTERNAL.fileUrl;
  private fileUrl: string = `${environment.HOST}${URL_MAP.EXTERNAL.fileUrl}`;

  constructor(private http: HttpClient) {}

  downloadFile(url: string): Observable<Blob> {
    console.log(url);
    const regex = /([^/]+)$/;
    const match = url.match(regex);
    return this.http.get(url, { responseType: 'blob' });
    // if (match && match[0]) {
    //   return this.http.post(`${this.baseEndpoint}`, {
    //     // "fullPath": `${this.fileUrl}/1741801928353289923005031825885837803316979071892557.docx`
    //     "fullPath": `${this.fileUrl}/${match[0]}` 
    //   }, { responseType: 'blob' });
    // } else {
    //   return throwError(() => new Error('No se pudo encontrar el archivo.'));
    // }
  }
}